// 部品 標準ボタン
import React, { useCallback, FormEvent } from 'react';
import { Row, Col } from 'react-bootstrap';
import { isBrouserEdge, isBrowserIe } from '../BrowserJudgment';

interface Props {
  label: string;
  strong: boolean;
  color?: string;
  handleClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  className?: string;
  disabled?: boolean;
  show?: boolean;
}

let row_class_name: string = '';
const DefaultButton: React.FC<Props> = ({
  label,
  strong,
  color = 'main-color',
  handleClick,
  className = '',
  disabled = false,
  show = true,
}) => {
  // 太字
  const str = strong ? <strong>{label}</strong> : <>{label}</>;

  if (show === true) {
    if (isBrowserIe()) {
      // IE
      row_class_name = 'ie-grid';
    } else if (isBrouserEdge()) {
      row_class_name = 'edge-grid';
    } else {
      // その他のブラウザ
      row_class_name = 'no-ie-grid';
    }
  } else {
    row_class_name = 'no-grid';
  }

  return (
    <Row className={`row-right-button ${row_class_name}`}>
      <Col className="text-right">
        <a className={`btn btn-xl btn-${color} ${className}`} onClick={handleClick}>
          {str}
        </a>
      </Col>
    </Row>
  );
};

export default DefaultButton;
